
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ButtonMoreDetails from './ButtonMoreDetails';

const MobileUpcomingBooking = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleMoreDetails = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="flex min-h-screen bg-white w-full mx-auto rounded-lg">
      <div className="w-full rounded-lg shadow-md p-4">
        <div className="bg-gray-100 p-4 rounded-md">

          <div className="flex justify-between items-center mb-4 text-sm text-gray-800">
            <div className="text-center">
              <p>08 Oct 2024</p>
              <p>09:00 AM</p>
            </div>
            <p>to</p>
            <div className="text-center">
              <p>08 Oct 2024</p>
              <p>09:00 PM</p>
            </div>
          </div>

          {/* Booking Details */}
          <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
            <p className="text-left">Location</p>
            <p className="font-semibold text-right">Cantonment complex, Opp Mangesh Honda</p>
            <p className="text-left">Booking ID</p>
            <p className="text-right">240807001005</p>
            <p className="text-left">Total Amount</p>
            <p className="text-right">₹900.00</p>
            <p className="text-left">Booking Status</p>
            <p className="text-right text-green-500 font-semibold">UpComing</p>
          </div>


          <div className="text-right mt-4">
            <button
              onClick={handleMoreDetails}
              className="text-[#FF9630] font-semibold hover:underline"
            >
              More Details &rarr;
            </button>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-50 flex justify-center items-center z-50">
          <div
            className="bg-white rounded-lg w-full max-w-6xl max-h-screen overflow-y-auto"
            style={{ height: "100vh" }}
          >
            <ButtonMoreDetails />
          </div>
        </div>
      )}
    </div>
  );
};

export default MobileUpcomingBooking;
